import ActionTypes from "./actionTypes";
import { getAppStore } from "../../store";
import { IScheduleAttrs } from "../../../models/Schedule/Schedule";

export class DiaryStoreActions {
    static loadingSchedules(loading: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADING_SCHEDULES, payload: loading });
    }
    static setSchedulesLoaded(state: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADED_SCHEDULES, payload: state });
    }
    static saveSchedules(schedules: IScheduleAttrs[]) {
        getAppStore().dispatch({ type: ActionTypes.SAVE_SCHEDULES, payload: schedules });
    }
    static addNewSchedule(schedule: IScheduleAttrs) {
        getAppStore().dispatch({ type: ActionTypes.ADD_NEW_SCHEDULE, payload: schedule });
    }
    static removeSchedule(scheduleId: string) {
        getAppStore().dispatch({ type: ActionTypes.DELETE_SCHEDULE, payload: scheduleId });
    }
    static getSchedules() {
        return getAppStore().getState().diary.schedules;
    }
}
